/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import {Subject} from "rxjs/Subject";
import {PropertyChangeEvent} from "./propertyChangedEvent";

import { Observable } from 'rxjs/Rx';
import { IDisposable } from '../../../../@inax/common'

export class IScriptEventProxy {
    
    Id: string;

    ScriptUnit: string;


    /**
     * You can call subscribe on this property to get informed for updates.
     *
     * @property ChangeEvent
     * @type {Observable<PropertyChangeEvent>}
     */
    ChangeEvent: Observable<PropertyChangeEvent>;
}